import { AxiosInstance } from 'axios';
import { ApiConfig, BASE_ADMIN_URL } from './api-config/api-config';

export const network: AxiosInstance = new ApiConfig({
  baseURL: BASE_ADMIN_URL,
  withCredentials: true
}).httpRequest;
